export const shouldRequireDingTalkAuth = () => {
  const value = process.env.REACT_APP_ENABLE_DINGTALK_AUTH;

  if (value === 'true') return true;
  if (value === 'false') return false;

  return process.env.NODE_ENV === 'production';
};
